import { createFileRoute, redirect } from '@tanstack/react-router'

import { WorkflowRoute } from '@/app/routes/_app/workflows/workflows'
import { getUserInfo } from '@/features/auth'
import { SignUpPage } from '@/pages/sign-up'

export const Route = createFileRoute('/sign-up')({
  component: RouteComponent,
  loader: async () => {
    try {
      const userInfo = await getUserInfo()
      if (userInfo) return redirect({ to: WorkflowRoute.to })
    } catch {
      // 🏡 stay on signup page
    }
  },
})

export const SignUpRoute = Route

function RouteComponent() {
  return <SignUpPage />
}
